import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr';

Vue.use(VueAwesomeSwiper);
